export * from './thread-detail.component';
